import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuilding_groups_groupId = z.any()
export type TagsGetBuilding_groups_groupId = z.infer<typeof tagsGetBuilding_groups_groupId>

export const paramsGetBuilding_groups_groupId = z.object({ "groupId": z.string().uuid() })
export type ParamsGetBuilding_groups_groupId = z.infer<typeof paramsGetBuilding_groups_groupId>

export const querystringGetBuilding_groups_groupId = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringGetBuilding_groups_groupId = z.infer<typeof querystringGetBuilding_groups_groupId>

export const responseGetBuilding_groups_groupId = z.object({ "payload": z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid(), "name": z.string(), "order": z.number().optional(), "address": z.string().optional(), "image": z.string().optional(), "createdAt": z.string(), "updatedAt": z.string(), "buildings": z.array(z.object({ "id": z.string().uuid(), "name": z.string(), "municipalityId": z.string().uuid(), "address": z.string().optional(), "image": z.string().optional() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuilding_groups_groupId = z.infer<typeof responseGetBuilding_groups_groupId>

interface IGetBuilding_groups_groupId extends BaseMethodType {
  tags: TagsGetBuilding_groups_groupId,
  params: ParamsGetBuilding_groups_groupId,
  querystring: QuerystringGetBuilding_groups_groupId,
  response: ResponseGetBuilding_groups_groupId
}
export const tagsPatchBuilding_groups_groupId = z.any()
export type TagsPatchBuilding_groups_groupId = z.infer<typeof tagsPatchBuilding_groups_groupId>

export const paramsPatchBuilding_groups_groupId = z.object({ "groupId": z.string().uuid() })
export type ParamsPatchBuilding_groups_groupId = z.infer<typeof paramsPatchBuilding_groups_groupId>

export const bodyPatchBuilding_groups_groupId = z.object({ "municipalityId": z.string().uuid(), "name": z.string().min(1).optional(), "address": z.string().optional(), "image": z.string().optional() })
export type BodyPatchBuilding_groups_groupId = z.infer<typeof bodyPatchBuilding_groups_groupId>

export const responsePatchBuilding_groups_groupId = z.object({ "payload": z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid(), "name": z.string(), "order": z.number().optional(), "address": z.string().optional(), "image": z.string().optional(), "createdAt": z.string(), "updatedAt": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchBuilding_groups_groupId = z.infer<typeof responsePatchBuilding_groups_groupId>

interface IPatchBuilding_groups_groupId extends BaseMethodType {
  tags: TagsPatchBuilding_groups_groupId,
  params: ParamsPatchBuilding_groups_groupId,
  body: BodyPatchBuilding_groups_groupId,
  response: ResponsePatchBuilding_groups_groupId
}
export const tagsDeleteBuilding_groups_groupId = z.any()
export type TagsDeleteBuilding_groups_groupId = z.infer<typeof tagsDeleteBuilding_groups_groupId>

export const paramsDeleteBuilding_groups_groupId = z.object({ "groupId": z.string().uuid() })
export type ParamsDeleteBuilding_groups_groupId = z.infer<typeof paramsDeleteBuilding_groups_groupId>

export const querystringDeleteBuilding_groups_groupId = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringDeleteBuilding_groups_groupId = z.infer<typeof querystringDeleteBuilding_groups_groupId>

export const responseDeleteBuilding_groups_groupId = z.any()
export type ResponseDeleteBuilding_groups_groupId = z.infer<typeof responseDeleteBuilding_groups_groupId>

interface IDeleteBuilding_groups_groupId extends BaseMethodType {
  tags: TagsDeleteBuilding_groups_groupId,
  params: ParamsDeleteBuilding_groups_groupId,
  querystring: QuerystringDeleteBuilding_groups_groupId,
  response: ResponseDeleteBuilding_groups_groupId
}
export const URL = '/building-groups/:groupId'
export const validation = {
  get: {
    tags: tagsGetBuilding_groups_groupId,
    params: paramsGetBuilding_groups_groupId,
    querystring: querystringGetBuilding_groups_groupId,
    response: responseGetBuilding_groups_groupId
  },
  patch: {
    tags: tagsPatchBuilding_groups_groupId,
    params: paramsPatchBuilding_groups_groupId,
    body: bodyPatchBuilding_groups_groupId,
    response: responsePatchBuilding_groups_groupId
  },
  delete: {
    tags: tagsDeleteBuilding_groups_groupId,
    params: paramsDeleteBuilding_groups_groupId,
    querystring: querystringDeleteBuilding_groups_groupId,
    response: responseDeleteBuilding_groups_groupId
  }
}
export interface Building_groups_groupId extends BaseRouteType {
  get: IGetBuilding_groups_groupId,
  patch: IPatchBuilding_groups_groupId,
  delete: IDeleteBuilding_groups_groupId
}